module.exports = __webpack_public_path__ + "img/logo-baokim.5c8a6a17.png";